(function () {

    'use strict';

    angular
        .module('AutoPrequal')
        .factory('ScrollFactory', ScrollFactory);

    ScrollFactory.$inject = ['$rootScope', '$timeout', '$state'];

    function ScrollFactory($rootScope, $timeout, $state) {

        /* order matters */
        var steps = [
            {
                "name": "welcome",
                "url": baseUrl + "root/app/views/welcome.html",
                "display": true,
                "scroll_hint": false,
                "cssClass": "active",
                "overflowing": false,
                "title": "Welcome",
                "titleFr": "Page d’accueil"
            },
            {
                "name": "applicantName",
                "url": baseUrl + "root/app/views/applicantName.html",
                "display": false,
                "scroll_hint": true,
                "cssClass": "",
                "overflowing": false,
                "title": "Tell us about yourself",
                "titleFr": "Parlez-nous de vous"
            },
            {
                "name": "applicantContact",
                "url": baseUrl + "root/app/views/applicantContact.html",
                "display": false,
                "scroll_hint": true,
                "cssClass": "",
                "overflowing": false,
                "title": "How can we reach you?",
                "titleFr": "Comment pouvons-nous vous joindre ?"
			},
			{
				"name": "applicantAddress",
				"url": baseUrl + "root/app/views/applicantAddress.html",
				"display": false,
				"scroll_hint": false,
				"cssClass": "",
				"overflowing": false,
				"title": 'Where do you live?',
				"titleFr": 'Où habitez-vous ?'
			},
            {
                "name": "birthdayMonth",
                "url": baseUrl + "root/app/views/birthdayMonth.html",
                "display": false,
                "scroll_hint": false,
                "cssClass": "",
                "overflowing": false,
                "title": 'Birthday Date - Month',
                "titleFr": 'Mois'
            },
            {
                "name": "birthdayDay",
                "url": baseUrl + "root/app/views/birthdayDay.html",
                "display": false,
                "scroll_hint": false,
                "cssClass": "",
                "overflowing": false,
                "title": 'Birthday Date - Day',
                "titleFr": 'Jour'
            },
            {
                "name": "birthdayYear",
                "url": baseUrl + "root/app/views/birthdayYear.html",
                "display": false,
                "scroll_hint": false,
                "overflowing": false,
                "title": 'Birthday Date - Year',
                "titleFr": 'Année'
			},
			{
				"name": "applicantIncome",
				"url": baseUrl + "root/app/views/applicantIncome.html",
				"display": false,
				"scroll_hint": false,
				"cssClass": "",
				"overflowing": false,
				"title": 'Gross income',
				"titleFr": 'Revenu annuel brut'
			},
			{
				"name": "applicantMortgage",
				"url": baseUrl + "root/app/views/applicantMortgage.html",
				"display": false,
				"scroll_hint": false,
				"cssClass": "",
				"overflowing": false,
				"title": 'Monthly rent or mortgage',
				"titleFr": 'Loyer ou versement hypothécaire mensuel'
			},
            {
                "name": "reviewTerms",
                "url": baseUrl + "root/app/views/reviewTerms.html",
                "display": false,
                "scroll_hint": false,
                "overflowing": false,
                "title": 'Terms and Conditions',
                "titleFr": 'Conditions'
            },
            {
                "name": "tradein",
                "url": baseUrl + "root/app/views/tradein.html",
                "display": false,
                "scroll_hint": false,
                "cssClass": "",
                "overflowing": false,
                "title": "Do you have a vehicle to trade in?",
				"titleFr": "Avez-vous un véhicule d’échange ?"
            },
            {
                "name": "tradeinHelp",
                "url": baseUrl + "root/app/views/tradeinHelp.html",
                "display": false,
                "scroll_hint": false,
                "cssClass": "",
                "overflowing": false,
                "title": "Do you need help assessing your trade-in value?",
				"titleFr": "Avez-vous besoin d’aide pour estimer la valeur de reprise de votre véhicule ?"
            },
            {
                "name": "tradeinDetails",
				"url": baseUrl + "root/app/views/tradeinDetails.html",
                "display": false,
                "scroll_hint": false,
                "cssClass": "",
                "overflowing": false,
                "title": "Let's assess the value of your vehicle",
				"titleFr": "Estimons la valeur de votre véhicule"
            },
            {
                "name": "tradeinEstimate",
				"url": baseUrl + "root/app/views/tradeinEstimate.html",
                "display": false,
                "scroll_hint": false,
                "cssClass": "",
                "overflowing": false,
                "title": 'Your Trade-in value',
				"titleFr": 'La valeur de reprise de votre véhicule'
            },
            {
                "name": "tradeinPayments",
                "url": baseUrl + "root/app/views/tradeinPayments.html",
                "display": false,
                "scroll_hint": false,
                "cssClass": "",
                "overflowing": false,
                "title": "Trade-in loan payments",
				"titleFr": "Versements au titre du prêt du véhicule"
            },
            {
                "name": "downPayment",
				"url": baseUrl + "root/app/views/downPayment.html",
                "display": false,
				"scroll_hint": false,
				"cssClass": "",
                "overflowing": false,
                "title": "What's your down payment?",
				"titleFr": "Quel est le montant de votre mise de fonds ?"
            },
            {
                "name": "results",
                "url": baseUrl + "root/app/views/results.html",
                "display": false,
				"scroll_hint": false,
				"cssClass": "",
                "overflowing": false,
                "title": 'Results',
                "titleFr": 'Résultat'
            }
        ];

        var removedSteps = [];

        function showStep(stepName) {
            $timeout(function () {
                steps[stepNameToNo(stepName)].display = true;
            })
        };

        function hideStep(stepName, wait) {
            if (wait) {
                $timeout(function () {
                    steps[stepNameToNo(stepName)].display = false;
                }, wait);
            } else {
                steps[stepNameToNo(stepName)].display = false;
            }
        };

        function hideOtherSteps(stepNameToShow) {
            angular.forEach(steps, function (stepName, index) {
                if (steps[stepNameToNo(stepNameToShow)] !== steps[index]) {
                    steps[index].display = false;
                }
            })
        }

        function removeStep(stepName) {
            try {
                var stepToRemove = steps[stepNameToNo(stepName)]
                stepToRemove.index = stepNameToNo(stepName)
                removedSteps.unshift(stepToRemove)
                steps.splice(stepNameToNo(stepName), 1);
            }
            catch (e) { }
        }

        function readdStep(stepName, afterStep) {
            try {
                var stepToReadd = removedSteps[removedStepNameToNo(stepName)];
                steps.splice(stepNameToNo(afterStep) + 1, 0, stepToReadd)
                removedSteps.splice(removedStepNameToNo(stepName), 1);
            }
            catch (e) { }
        }

        function setClass(stepNo, cssClass) {
            steps[stepNo].cssClass = cssClass;
        };

        function goToStep(stepName, duration) {
            duration = typeof duration !== 'undefined' ? duration : 1000;
            if ($(window).width() > 769) {
                $('section.' + $rootScope.currentStep).addClass('inactive');
            }
            $rootScope.scrolling = true;
            $timeout(function () {
                $rootScope.scrolling = true;
                $rootScope.snapIndex = stepNameToNo(stepName);
                steps[$rootScope.snapIndex].cssClass = steps[$rootScope.snapIndex].cssClass + " active";
                if ($(window).width() > 769) {
                    $("section." + stepName).velocity("scroll", {
                        container: $('.container-right'),
                        duration: duration,
                        easing: "easeOutQuad",
                        complete: function (el) {
                            if ($rootScope.snapIndex > 0) {
                                steps[$rootScope.snapIndex - 1].cssClass = steps[$rootScope.snapIndex - 1].cssClass ? steps[$rootScope.snapIndex - 1].cssClass.replace(/\s?active/, "") : "";
                            }
                            if ($rootScope.currentStep !== "productError" && $rootScope.currentStep !== "error" && $rootScope.currentStep !== "maintenance") $rootScope.currentStep = stepName;
                            $state.go('.', { hash: $rootScope.currentStep })
                            $rootScope.scrolling = false;
                        }
                    });
                }
                else {
                    if ($rootScope.snapIndex > 0) {
                        steps[$rootScope.snapIndex - 1].cssClass = steps[$rootScope.snapIndex - 1].cssClass ? steps[$rootScope.snapIndex - 1].cssClass.replace(/\s?active/, "") : "";
                    }
                    if ($rootScope.currentStep !== "productError" && $rootScope.currentStep !== "error" && $rootScope.currentStep !== "maintenance") $rootScope.currentStep = stepName;
                    $state.go('.', { hash: $rootScope.currentStep })
                    $rootScope.scrolling = false;
                }
            });
        };

        function setActive(stepName) {
            var step = stepNameToNo(stepName);
            for (var i = 0; i < steps.length; i++) {
                if (steps[i].cssClass) {
                    steps[i].cssClass = steps[i].cssClass.replace(/\s?active/, "");
                }
            }
            steps[step].cssClass = steps[step].cssClass + " active";
        }

        function stepNameToNo(stepName) {
            var indexes = $.map(steps, function (obj, index) {
                if (obj.name == stepName) {
                    return index;
                }
            });
            return indexes[0];
        }

        function removedStepNameToNo(stepName) {
            var indexes = $.map(removedSteps, function (obj, index) {
                if (obj.name == stepName) {
                    return index;
                }
            });
            return indexes[0];
        }

        function stepNoToName(stepNo) {
            return steps[stepNo].name;
        };

        function lastVisibleStep(stepName) {
            var stepNo = stepNameToNo(stepName);
            for (var i = steps.length - 1; i > stepNo; i = i - 1) {
                steps[i].display = false;
            }
        };

        function getLastStep() {
            for (var i = steps.length - 1; i >= 0; i--) {
                if (steps[i].display) return steps[i].name;
            }
        }

        function getPrevStep(currentStep) {
            var currentNum = stepNameToNo(currentStep);
            while (--currentNum > 0) {
                if (steps[currentNum].display) break;
            }
            return stepNoToName(currentNum);
        }

        var scrollFactory = {
            "showStep": showStep,
            "hideStep": hideStep,
            "setClass": setClass,
            "goToStep": goToStep,
            "removeStep": removeStep,
            "readdStep": readdStep,
            "stepNoToName": stepNoToName,
            "stepNameToNo": stepNameToNo,
            "lastVisibleStep": lastVisibleStep,
            "setActive": setActive,
            "steps": steps,
            "getLastStep": getLastStep,
            "getPrevStep": getPrevStep,
            "hideOtherSteps": hideOtherSteps
        };

        return scrollFactory;

    };

})();
